import React from "react";
import {useOutlet} from "react-router-dom";
import Box from "@mui/material/Box";


const Page = ({children}) => {
    const outlet = useOutlet()

    return <>
        <Box hidden={!!outlet}>
            {children}
        </Box>
        {outlet}
    </>
}

export default Page;